function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
import React from 'react';
import clsx from 'clsx';
import { ParameterState } from '@isyc-react/types';
import { OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
import { useTranslation } from 'react-i18next';
import { nsoncustomer } from "../../../../i18n/namespaces";
import { InputParameterEditRemarksModal } from "./input-parameter-edit-remarks-modal.container";
export const ParameterContainerDefault = props => {
  const {
    parameter,
    showAddDeleteButtons = true,
    showVerifyButtons = true,
    onInsert,
    onDelete,
    onChangeField,
    children
  } = props;
  const {
    label,
    obligatory,
    repeatable,
    verificable,
    state,
    remarks
  } = parameter;
  const {
    t
  } = useTranslation(nsoncustomer.common);
  const [modal, setModal] = React.useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "parameter-item-container"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, label, " ", obligatory && /*#__PURE__*/React.createElement("span", {
    className: "required"
  }, "*"))), /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-0 col"
  }, children), showVerifyButtons && verificable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: 'add-parameter-tooltip'
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: clsx({
        'text-start': remarks
      })
    }, t('core.parameter.editCommentsTooltipEdit'), remarks ? ` ${t('core.parameter.editCommentsTooltipFilled')}:` : ''), remarks && /*#__PURE__*/React.createElement("div", {
      className: "text-start"
    }, /*#__PURE__*/React.createElement("b", null, remarks))))
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('pe-0 col-auto mdi', remarks ? 'mdi-comment-alert' : 'mdi-comment-alert-outline', 'text-primary cursor-pointer font-size-24'),
    onClick: () => setModal(true)
  })), /*#__PURE__*/React.createElement("span", {
    className: "pe-0 col-auto"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: clsx('btn btn-sm', state === ParameterState.VALID ? 'btn-success' : 'btn-outline-primary'),
    onClick: () => onChangeField({
      state: ParameterState.VALID
    })
  }, t('core.parameter.validate'))), /*#__PURE__*/React.createElement("span", {
    className: "pe-0 col-auto"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: clsx('btn btn-sm btn-outline-primary', state === ParameterState.INVALID ? 'btn-danger' : 'btn-outline-primary'),
    onClick: () => onChangeField({
      state: ParameterState.INVALID
    })
  }, t('core.parameter.invalidate')))), showAddDeleteButtons && /*#__PURE__*/React.createElement("div", {
    className: "col-auto text-primary"
  }, repeatable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    className: "cursor-pointer text-decoration-underline",
    onClick: onInsert
  }, t('core.parameter.addParameter')), /*#__PURE__*/React.createElement("span", {
    className: "mx-1"
  }, "|")), /*#__PURE__*/React.createElement("a", {
    className: "cursor-pointer text-decoration-underline",
    onClick: onDelete
  }, t('core.parameter.removeParameter'))))), modal && /*#__PURE__*/React.createElement(InputParameterEditRemarksModal, _extends({
    modal: modal,
    setModal: setModal,
    remarks: remarks,
    onFinish: remarks => onChangeField({
      remarks
    })
  }, props)));
};